<script>
import { defineAsyncComponent } from "vue";
import { componentStore } from "@common/componentStore/componentStore";
import { ddStore } from "@common/ddStore";
import { library } from "@common/library/library";
import { actionStore } from "@common/actionStore";

const vmsOppWorkflowManagerConfig = {
    cId: "vmsOppWorkflowManager",
    cType: "vmsOppWorkflowManager",
    cTitle: "Opportunity Workflow Manager",
    cTemplate: `<div class="vms-opp-workflow-manager" :id="'vmsOppWorkflowManagerWrapper' + cId">
                    <div class="vms-opp-workflow-manager-left">
                        <div class="vms-opp-workflow-manager-text-area">
                            <span class="vms-opp-workflow-manager-workflow-label">Workflow:</span>
                            <div class="vms-opp-workflow-manager-dropdown-area">
                                <control name="WORKFLOW_LIST" :prop-config="controls.WORKFLOW_LIST" :items="workflowList"></control>
                            </div>
                        </div>
                        <div class="clearfix"></div>
                    </div>
                    <control name="SUBMIT_BUTTON"></control>
                </div>`,
    controls: [
        {
            name: 'WORKFLOW_LIST',
            type: 'multiselect',
            title: 'Workflows',
            width: '300px',
            fields: { text: 'text', value: 'value' },
            showClearButton: true
        },
        {
            name: 'SUBMIT_BUTTON',
            label: 'Submit',
            type: 'button',
            onclick: 'manualSave',
            display: (typeof VUE_PROJECT_NAME !== 'undefined' && VUE_PROJECT_NAME !== 'coordinator')
                || (typeof PROJECT_NAME !== 'undefined' && PROJECT_NAME !== 'coordinator'),
        }
    ]
};

let vmsOppWorkflowManagerCmp = {
    name: 'vmsOppWorkflowManager',
    props: {
    },
    data() {
        return {
            oppId: false,
            workflowId: 0,
            workflowList: [],
            selectedRecordIds: [],
            filteredItems: {},
            selectedItems: {},
            selectedItemsFullData: {},
            filterAdditionalConfig: {
                allowCustomValue: false,
                allowFiltering: true,
                filterType: 'Contains',
                showResultsAfterFiltersApplied: true,
                notShowMissingOptions: true
            },
            loading: true
        };
    },
    computed: {
        selectedOppId() {
            return this.contextOppId || this.oppId;
        }
    },
    methods: {
        async onLoad() {
            ddStore.preloadGroup('COMMON');
            // eslint-disable-next-line camelcase
            if (typeof profile_getFormObject === 'function') {
                let theForm = profile_getFormObject();
                if (theForm && theForm.recordID) {
                    this.oppId = theForm.recordID.value;
                    // eslint-disable-next-line camelcase
                    if (typeof SmartTabs === 'object' && typeof general_resizeToContent === 'function') {
                        general_resizeToContent(1, 0, 5);
                    }
                }
            }
            if (
                typeof profileFieldEditPermissions === 'object'
                && typeof profileFieldEditPermissions[0] === 'object'
                && profileFieldEditPermissions[0]?.includes('WORKFLOW_ID')
            ) {
                this.controls.WORKFLOW_LIST.disabled = true;
            }
            library.showLoadingIndicator('vmsOppWorkflowManagerWrapper' + this.cId);
            await this.getWorkflowList();
            library.hideLoadingIndicator('vmsOppWorkflowManagerWrapper' + this.cId);
            this.loading = false;
        },
        async getWorkflowList() {
            let response = await this.sDs.post('sds_getWorkflowList', 1);
            if (response.status === 'success' && response.data) {
                let workflowList = [];
                for (let i in response.data) {
                    if (i === 'length') continue;
                    workflowList.push({
                        text: response.data[i].WORKFLOW_TITLE,
                        value: response.data[i].WORKFLOW_ID,
                    });
                }
                this.workflowList = workflowList;
            }
            let sOppId = this.selectedOppId;
            if (sOppId) {
                let response = await this.sDs.post('sds_getProfileField', 'opp', sOppId, ['OPP_WORKFLOW_ID']);
                if (response.status === 'success' && response.data) {
                    let tmpWorkflowId = [];
                    if (response.data[sOppId]['OPP_WORKFLOW_ID']) {
                        if (Array.isArray(response.data[sOppId]['OPP_WORKFLOW_ID'])) {
                            for (let i in response.data[sOppId]['OPP_WORKFLOW_ID']) {
                                tmpWorkflowId.push(parseInt(response.data[sOppId]['OPP_WORKFLOW_ID'][i], 10));
                            }
                        } else {
                            tmpWorkflowId = [parseInt(response.data[sOppId]['OPP_WORKFLOW_ID'], 10)];
                        }
                    }
                    if (tmpWorkflowId.length) {
                        this.workflowId = library.cloneObj(tmpWorkflowId);
                        this.controls.WORKFLOW_LIST.value = library.cloneObj(tmpWorkflowId);
                    }
                }
            }
        },
        async manualSave() {
            let sOppId = this.selectedOppId;
            let newWorkflowId = this.controls.WORKFLOW_LIST.value;
            let isChanged = !Array.isArray(this.workflowId)
                            || !Array.isArray(newWorkflowId)
                            || (
                                Array.isArray(this.workflowId)
                                && Array.isArray(newWorkflowId)
                                && !library.isEqualObj(this.workflowId.sort(), newWorkflowId.sort())
                            );
            if (isChanged && sOppId) {
                let response = await this.sDs.post('sds_updateProfileField', 'opp', sOppId, { 'OPP_WORKFLOW_ID': newWorkflowId });
                if (response.status !== 'success') {
                    library.showToast('We could not save your information.');
                    return;
                }
                this.workflowId = newWorkflowId;
                if (newWorkflowId.length) {
                    await library.showDialog('Do you want to create affiliations for all activities in the workflow for already affiliated volunteers?', () => {
                        this.sDs.post('sds_affiliateVolWithOppActivities', sOppId);
                    }, false, { name: 'confirmActivityAffiliation' });
                }
            } else {
                // library.showToast('Nothing to save!');
            }
        },
    }
};

componentStore.initComponent(vmsOppWorkflowManagerCmp, vmsOppWorkflowManagerConfig);
export { vmsOppWorkflowManagerCmp, vmsOppWorkflowManagerConfig };
export default vmsOppWorkflowManagerCmp;

</script>

<style scoped>
.vms-opp-workflow-manager {
    padding: 5px;
    width: 400px;
}
.vms-opp-workflow-manager-left {
    float: left;
}
.vms-opp-workflow-manager .clearfix {
    clear: both;
}
:deep(.vms-opp-workflow-manager .filter-status) {
    display: none;
}
</style>

<style>
span.vms-opp-workflow-manager-workflow-label {
    font-weight: bold;
}
.vms-opp-workflow-manager-dropdown-area {
    display: inline-block;
    position: relative;
    top: 4px;
    left: 10px;
}
</style>
